module.exports = __webpack_public_path__ + "img/TS-flag.cfcf1b64.svg";